export default "__VITE_ASSET__7_QI_imT__"